export const getApplicationFormBySeason = (seasonId, countrySfId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationFormQuestionCs?` +
      `filter[where][or][0][showSeasonRExternalIdC]=${seasonId}&` +
      `filter[where][or][1][countryC]=${countrySfId}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  ).then(response => response.json());
// /ApplicationAnswerOptionCs?filter[where][showDataFieldRExternalIdC]=8ecd4ccc-f847-48d3-b5a8-257ecd502fe103
export const getFieldOptionById = fieldId =>
  fetch(
    `${
      process.env.REACT_APP_API_URL
    }/ApplicationAnswerOptionCs?filter[where][showDataFieldC]=${fieldId}&filter[order]=name%20ASC`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  ).then(response => response.json());



// WEBPACK FOOTER //
// ./src/api/applicationFormQuestionAPI.js